import getProjectBySlug from './getProjectBySlug'
import getProjects from './getProjects'

const projects = {
  getProjectBySlug,
  getProjects
}

export default projects
